"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var button_1 = tslib_1.__importDefault(require("../../../../button"));
var checkbox_1 = tslib_1.__importDefault(require("../../../../checkbox"));
var config_provider_1 = require("../../../../config-provider");
var dropdown_1 = tslib_1.__importDefault(require("../../../../dropdown"));
var empty_1 = tslib_1.__importDefault(require("../../../../empty"));
var NormalFilterFill_1 = require("../../../../Icons/NormalFilterFill");
var radio_1 = tslib_1.__importDefault(require("../../../../radio"));
var useSyncState_1 = tslib_1.__importDefault(require("../../../../util/hooks/useSyncState"));
var _menu_1 = tslib_1.__importDefault(require("../../../_menu"));
var FilterWrapper_1 = tslib_1.__importDefault(require("./FilterWrapper"));
var SubMenu = _menu_1.default.SubMenu, MenuItem = _menu_1.default.Item;
function hasSubMenu(filters) {
    return filters.some(function (_a) {
        var children = _a.children;
        return children;
    });
}
function renderFilterItems(_a) {
    var filters = _a.filters, prefixCls = _a.prefixCls, filteredKeys = _a.filteredKeys, filterMultiple = _a.filterMultiple, locale = _a.locale;
    if (filters.length === 0) {
        // wrapped with <div /> to avoid react warning
        // https://github.com/ant-design/ant-design/issues/25979
        return (React.createElement("div", { style: {
                margin: '16px 0',
            } },
            React.createElement(empty_1.default, { image: empty_1.default.PRESENTED_IMAGE_SIMPLE, description: locale.filterEmptyText, imageStyle: {
                    height: 24,
                } })));
    }
    return filters.map(function (filter, index) {
        var key = String(filter.value);
        if (filter.children) {
            return (React.createElement(SubMenu, { key: key || index, title: filter.text, popupClassName: "".concat(prefixCls, "-dropdown-submenu") }, renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                locale: locale,
            })));
        }
        var Component = filterMultiple ? checkbox_1.default : radio_1.default;
        return (React.createElement(MenuItem, { key: filter.value !== undefined ? key : index },
            React.createElement(Component, { checked: filteredKeys.includes(key) }),
            React.createElement("span", null, filter.text)));
    });
}
function FilterDropdown(props) {
    var _a, _b;
    var _c;
    var prefixCls = props.prefixCls, column = props.column, dropdownPrefixCls = props.dropdownPrefixCls, columnKey = props.columnKey, filterMultiple = props.filterMultiple, filterState = props.filterState, triggerFilter = props.triggerFilter, locale = props.locale, children = props.children, getPopupContainer = props.getPopupContainer;
    var filterDropdownVisible = column.filterDropdownVisible, onFilterDropdownVisibleChange = column.onFilterDropdownVisibleChange;
    var _d = tslib_1.__read(React.useState(false), 2), visible = _d[0], setVisible = _d[1];
    var filtered = !!(filterState &&
        (((_c = filterState.filteredKeys) === null || _c === void 0 ? void 0 : _c.length) || filterState.forceFiltered));
    var triggerVisible = function (newVisible) {
        setVisible(newVisible);
        if (onFilterDropdownVisibleChange) {
            onFilterDropdownVisibleChange(newVisible);
        }
    };
    var mergedVisible = typeof filterDropdownVisible === 'boolean' ? filterDropdownVisible : visible;
    // ===================== Select Keys =====================
    var propFilteredKeys = filterState && filterState.filteredKeys;
    var _e = tslib_1.__read((0, useSyncState_1.default)(propFilteredKeys || []), 2), getFilteredKeysSync = _e[0], setFilteredKeysSync = _e[1];
    var onSelectKeys = function (_a) {
        var selectedKeys = _a.selectedKeys;
        setFilteredKeysSync(selectedKeys);
    };
    React.useEffect(function () {
        onSelectKeys({ selectedKeys: propFilteredKeys || [] });
    }, [propFilteredKeys]);
    // ====================== Open Keys ======================
    var _f = tslib_1.__read(React.useState([]), 2), openKeys = _f[0], setOpenKeys = _f[1];
    var openRef = React.useRef();
    var onOpenChange = function (keys) {
        openRef.current = window.setTimeout(function () {
            setOpenKeys(keys);
        });
    };
    var onMenuClick = function () {
        window.clearTimeout(openRef.current);
    };
    React.useEffect(function () { return function () {
        window.clearTimeout(openRef.current);
    }; }, []);
    // ======================= Submit ========================
    var internalTriggerFilter = function (keys) {
        var mergedKeys = keys && keys.length ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) {
            return null;
        }
        if ((0, isEqual_1.default)(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys)) {
            return null;
        }
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys,
        });
    };
    var onConfirm = function () {
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    var onReset = function () {
        setFilteredKeysSync([]);
        triggerVisible(false);
        internalTriggerFilter([]);
    };
    var doFilter = function (param) {
        if (param === void 0) { param = { closeDropdown: true }; }
        triggerVisible(!param.closeDropdown);
        internalTriggerFilter(getFilteredKeysSync());
    };
    var onVisibleChange = function (newVisible) {
        if (newVisible && propFilteredKeys !== undefined) {
            // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefiend)
            setFilteredKeysSync(propFilteredKeys || []);
        }
        triggerVisible(newVisible);
        // Default will filter when closed
        if (!newVisible && !column.filterDropdown) {
            onConfirm();
        }
    };
    // ======================== Style ========================
    var dropdownMenuClass = (0, classnames_1.default)((_a = {},
        _a["".concat(dropdownPrefixCls, "-menu-without-submenu")] = !hasSubMenu(column.filters || []),
        _a));
    var dropdownContent;
    if (typeof column.filterDropdown === 'function') {
        dropdownContent = column.filterDropdown({
            prefixCls: "".concat(dropdownPrefixCls, "-custom"),
            setSelectedKeys: function (selectedKeys) { return onSelectKeys({ selectedKeys: selectedKeys }); },
            selectedKeys: getFilteredKeysSync(),
            confirm: doFilter,
            clearFilters: onReset,
            filters: column.filters,
            visible: mergedVisible,
        });
    }
    else if (column.filterDropdown) {
        dropdownContent = column.filterDropdown;
    }
    else {
        var selectedKeys = (getFilteredKeysSync() || []);
        dropdownContent = (React.createElement(React.Fragment, null,
            React.createElement(_menu_1.default, { multiple: filterMultiple, prefixCls: "".concat(dropdownPrefixCls, "-menu"), className: dropdownMenuClass, onClick: onMenuClick, onSelect: onSelectKeys, onDeselect: onSelectKeys, selectedKeys: selectedKeys, getPopupContainer: getPopupContainer, openKeys: openKeys, 
                // @ts-ignore
                onOpenChange: onOpenChange }, renderFilterItems({
                filters: column.filters || [],
                prefixCls: prefixCls,
                filteredKeys: getFilteredKeysSync(),
                filterMultiple: filterMultiple,
                locale: locale,
            })),
            React.createElement("div", { className: "".concat(prefixCls, "-dropdown-btns") },
                React.createElement(button_1.default, { type: "link", size: "small", disabled: selectedKeys.length === 0, onClick: onReset }, locale.filterReset),
                React.createElement(button_1.default, { type: "primary", size: "small", onClick: onConfirm }, locale.filterConfirm))));
    }
    var menu = (React.createElement(FilterWrapper_1.default, { className: "".concat(prefixCls, "-dropdown") }, dropdownContent));
    var filterIcon;
    if (typeof column.filterIcon === 'function') {
        filterIcon = column.filterIcon(filtered);
    }
    else if (column.filterIcon) {
        filterIcon = column.filterIcon;
    }
    else {
        filterIcon = React.createElement(NormalFilterFill_1.NormalFilterFill, null);
    }
    var direction = React.useContext(config_provider_1.ConfigContext).direction;
    return (React.createElement("div", { className: (0, classnames_1.default)("".concat(prefixCls, "-column")) },
        React.createElement("span", { className: "".concat(prefixCls, "-column-title") }, children),
        React.createElement("span", { className: (0, classnames_1.default)("".concat(prefixCls, "-trigger-container"), (_b = {},
                _b["".concat(prefixCls, "-trigger-container-open")] = mergedVisible,
                _b)), onClick: function (e) {
                e.stopPropagation();
            } },
            React.createElement(dropdown_1.default, { overlay: menu, trigger: ['click'], visible: mergedVisible, onVisibleChange: onVisibleChange, getPopupContainer: getPopupContainer, placement: direction === 'rtl' ? 'bottomLeft' : 'bottomRight' },
                React.createElement("span", { role: "button", tabIndex: -1, className: (0, classnames_1.default)("".concat(prefixCls, "-trigger"), {
                        active: filtered,
                    }) }, filterIcon)))));
}
exports.default = FilterDropdown;
//# sourceMappingURL=FilterDropdown.js.map